import { TireList } from "@/@types/Tire";
import { ROUTES } from "@/config/routes";
import { FallbackImage } from "../common";
import NoContent from "../common/NoContent";
import Link from "next/link";

type Props = {
  tires: TireList;
};

export default function TireListCard({ tires }: Props) {
  if (!tires || !tires.data || tires.data.Tires.length === 0) {
    return <NoContent message="No hay llantas disponibles." />;
  }

  return (
    <div className="grid  gap-6 grid-cols-2 md:grid-cols-3 bg-gray-100">
      {tires.data.Tires.map((tire, index) => (
        <Link
        href={ROUTES.tires.details(tire.industrySlug, tire.slug)}
        key={`${tire.slug}-${index}` }
        className="bg-white hover:shadow-lg transition-shadow duration-200"
      >
        <div className="aspect-square">
          <FallbackImage
            width={600}
            height={600}
            src={tire.image}
            alt={tire.title}
            className="w-full h-full object-contain"
          />
        </div>
        <div className="text-center py-2 bg-silver">
          <p className="text-lg uppercase font-bold text-gray-800">{tire.title}</p>
        </div>
      </Link>
      ))}
    </div>
  );
}
